import { ClientSideWizardState, ClientSideWizardCurrentProcessState, ClientSideWizardProviderProps } from './types';

const defaultCurrentProcessState: ClientSideWizardCurrentProcessState = {
  currentStepConfig: null,
  stepId: undefined,
  completedSteps: 0,
  formData: {
    data: null,
    currentStep: null,
  },
  preloadedFormDataConfig: {
    data: null,
    currentStep: null,
  },
};

const defaultClientSideWizardStatesValues: ClientSideWizardState = {
  preloadedData: {
    data: null,
    currentStep: null,
  },
  stepsConfig: {},
  formData: defaultCurrentProcessState?.formData ?? {},
  errorState: { errors: null, setNetworkCallErrors: () => {} },
  currentProcessState: defaultCurrentProcessState,
  goToNextWizardStep: (formData: any) => {},
  goToPreviousWizardStep: () => {},
  currentStepConfig: { Component: null, parameters: {}, cancelHidden: true, stepId: defaultCurrentProcessState.stepId },
  hasStepIndicator: true,
  totalSteps: 0,
  completedSteps: 0,
  shouldNavigateTo: null,
  setState: () => {},
  initialized: false,
};

const defaultClientSideWizardProviderValues: ClientSideWizardProviderProps = {
  preloadedFormDataConfig: { data: {} },
  stepsConfig: {},
  processName: '',
  stateHandler: (data: any) => {},
};

export { defaultClientSideWizardProviderValues, defaultClientSideWizardStatesValues };
